export enum ContentVisibilityRuleElementTypeEnum {
    CB_IN_ROW = 'CB_IN_ROW',
    ROW = 'ROW'
}
